import { Record } from 'immutable';

export default class ReplacementModelPeriodDeviationRecord extends Record({
  day: 'weekday',
  multiplyFactor: null,
  price: null,
  strategy: null,
  from: null,
  to: null,
  timeCode: null,
  articleName: null,
  articleNumber: null,
  articleFactor: undefined, // snapshot of the per-segment debit factor at booking time
}) {
}
